import React, { useState } from 'react';
import moment from 'moment';
import copyToClipboard from 'copy-to-clipboard';

import { convertStateCodeToStateName } from 'common/util/stateCodes';

import './UPOrdersHitlistTable.less';

const formatDate = (dateString) => {
  if (!dateString) return '';
  return moment(dateString).format('YYYY-MM-DD');
};

const UPOrdersHitlistCopyDetails = ({ utilityActivation }) => {
  const [isCopied, setIsCopied] = useState(false);

  if (!utilityActivation) {
    return null;
  }

  const {
    address,
    item: electricityItem,
    partner,
    provider,
    salesRep,
    user: renter,
  } = utilityActivation;

  const buildCopyText = () => {
    const salesRepName = `${salesRep?.firstName || ''} ${salesRep?.lastName || ''}`.trim();
    const renterName = `${renter.firstName || ''} ${renter.lastName || ''}`.trim();
    const phone = renter.phone || '';
    const partnerName = partner?.name || '';
    const displayAddress = address?.display || '';
    const stateName = convertStateCodeToStateName(address?.stateCode) || '';
    const accountRequestedAt = formatDate(utilityActivation.accountRequestedAt);
    const leaseStartDate = formatDate(utilityActivation.leaseStartDate);
    const providerTitle = provider?.title || '';
    const planTitle = electricityItem?.plan?.title || '';

    return [
      salesRepName,
      renterName,
      phone,
      partnerName,
      displayAddress,
      stateName,
      '', // We might not have the value for this column
      accountRequestedAt,
      leaseStartDate,
      providerTitle,
      planTitle,
    ].join('\t');
  };

  const onCopyAllDetails = (e) => {
    e.preventDefault();
    e.stopPropagation();

    copyToClipboard(buildCopyText());
    setIsCopied(true);

    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <span styleName="copyAllDetails" onClick={onCopyAllDetails}>
      {isCopied ? 'Copied!' : 'Click to copy all details'}
    </span>
  );
};

UPOrdersHitlistCopyDetails.displayName = 'UPOrdersHitlistCopyDetails';

export default UPOrdersHitlistCopyDetails;
